/* import components */
import Menu from "../components/Menu";
import Spinner from "../components/Spinner";
import Container from "react-bootstrap/Container";

const Loading = () => {

  return (
    <>  
      <Menu title="RydeHELP" />
      <Container style={{ paddingTop: "20px", textAlign: "center"}}>
          <Spinner />
      </Container>
    </>
    );
}

export default Loading;